import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const LANGUAGE_STORAGE_KEY = "appLanguage";

const resources = {
  en: {
    translation: {
      common: {
        terms: "Terms and conditions",
        privacy: "Privacy policy.",
        and: "and",
        okay: "Okay",
        continue: "Continue",
        goBack: "Go Back",
        retry: "Retry",
        scan: "Scan",
        getHelp: "Get Help",
        pleaseWait: "Please wait...",
        next: "Next",
        enter: "Enter",
        verifying: "Verifying...",
        uploading: "Submitting...",
        submit: "Submit",
        review: "Re-record",
        language: "language",
        chooseYourLanguage: "Choose your\nlanguage",
        tamil: "Tamil",
        english: "English",
        desktopInterest: "Thank you for your interest in participating in the",
        desktopQr: "Please scan the QR code on your phone to enter the experience :",
        rotate_message: "This website does not support landscape mode.",
        rotate_messageBoldPart: "Please use the website in vertical mode!",
        buymore: "Buy More"
      },
      auth: {
        signUp: "SIGN UP",
        logIn: "LOG IN",
        name: "Name",
        phoneNumber: "Phone Number",
        phoneNumberLabel: "Phone number",
        state: "State",
        completeKurals: "Complete Kurals and\nwin rewards!",
        invalidPhone: "Enter valid phone number",
        notRegistered: "This number is not registered.",
        agreeError: "Please agree to the Terms and Conditions.",
        stateError: "Please select your state.",
        registrationFailed: "Registration failed. Please try again.",
        agreeText: "By signing up you agree to our",
        alreadyRegistered: "Already registered?",
        dontHaveAccount: "Don't have an account?",
        signUpLink: "Sign up",
        logInLink: "Log in",
        sendingOtp: "Sending OTP...",
        loggedIn: "Logged In!",
        otp: "OTP",
        enterOtp: "ENTER OTP",
        otpSent: "We have sent an OTP to",
        enterAllDigits: "Enter all 6 digits",
        wrongOtp: "Wrong OTP",
        codeExpire: "Code will expire in :",
        resendCode: "Resend Code",
        otpVerify: "OTP Verify",
        done: "Done",
        go: "Go",
        otpResent: "OTP resent to your number",
        tryLater: "Please try again later",
      },
      dashboard: {
        greeting: "Hi {{name}}",
        kuralOptionsInstruction: "Click on any Kural for more options",
        scanInstruction: "Scan biscuits from your pack or type in the missing words.",
        scanBiscuit: "Scan Biscuit",
        recordVideo: "Record Video",
        scanStep: "SCAN BISCUIT",
        completeStep: "COMPLETE KURAL",
        sendVideoStep: "SEND VIDEO RECORDING",
        level1: "LEVEL 1",
        level2: "LEVEL 2",
        howLevel1: "Scan a biscuit with a\nkural word on it.",
        claimReward: "Claim your cashback reward!",
        howLevel2: "Complete the kural using more\n biscuits, or fill it yourself.",
        howVideo: "Send a recording of you reciting\n the kural to",
        winBig: " WIN BIG!",
        kuralTitle: "KURAL {{id}}",
        menuRewards: "REWARDS",
        menuHowToPlay: "HOW TO PLAY",
        menuContactUs: "CONTACT US",
        menuTerms: "TERMS AND\nCONDITIONS",
        TypeKural: "Type the Kural",
        WrongWord: "Wrong answer.\nTry again!",
        OOPS: "Wrong answer.\nTry again!",
      },
      reward: {
        level1Badge: "LEVEL 1",
        level1Text: "Scan a biscuit with a kural word on it.",
        level1Strong: "Claim your guaranteed Amazon Pay voucher!",
        level2Badge: "LEVEL 2",
        level2Text: "Complete a Kural, teach it to your child,\nand record them reciting it —",
        level2Strong: "win a bicycle every hour*, a trip to Kanyakumari!",
      },
      scan: {
        packDetails: "Scan pack for details.",
        machinePrompt: "Scan the 16 digit code from\nthe back of your pack:",
        machineSuccess: "Machine Code Scanned\nSuccessfully!",
        capturedAlt: "Captured frame - tap the machine code",
        level1: "Level 1:",
        level2: "Level 2:",
        scanBiscuit: "Scan Biscuit",
        recordVideo: "Record Video",
        scanYourKural: "Scan biscuit horizontally and scan one biscuit at a time only.",
        scanningBiscuit: "Scanning your biscuit...",
        holdStill: "Please hold still",
        cameraNotFound: "Camera not found.",
        cameraAccess: "Please allow camera access or connect a camera.",
        scanFailed: "Scan failed.",
        tryAgain: "Try again.",
        congratsLevel1: "Congratulations! You\nfound a kural word and\nare eligible for Level 2!",
        foundError: "Something went wrong. Please try again.",
        noBiscuit: "No biscuit detected. Please try again.",
        noBiscuitVisible: "No biscuit detected. Make sure the biscuit is visible.",
        textUnclear: "Text unclear. Please hold the camera steadier.",
        textUnreadable: "Text is unreadable. Try better lighting.",
        machineCodeAlreadyScanned: "This Machine Code has already been scanned.",
        alreadyScanned: "This biscuit has already been scanned! Scan a different Kural Word Biscuit.",
        genericError: "An error occurred. Please try again.",
        invalidMobile: "Please enter a valid mobile number.\nTry again.",
        invalidSku: "Couldn't scan the 16-digit code.\n Try Again!",
        notConfigured: "Couldn't scan the 16-digit\n code. Try Again!",
        mobileMismatch: "Mobile number\ndoesn't match. Try Again!",
        serviceError: "Service unavailable.\nPlease try again!",

        // ── Specific biscuit-scan failure reasons ──
        // (contains \n so the "Scan again." part renders bold on its own line)
        nonKuralBiscuit: "Non-Kural Biscuit detected.\nScan again.",
        multipleBiscuits: "More Than One Biscuit Detected.\nScan again.",
        noBiscuitDetected: "No Biscuit Detected.\nScan again.",
      },
      video: {
        unableAccess: "Unable to access camera or microphone. Please check permissions.",
        noVideo: "No video found",
        uploadFailed: "Upload failed",
        clickStart: "Click to start recording",
        recording: "Recording... {{time}}",
        completedKural: "You have completed\nyour Kural!",
        teachChild: "Teach your child the Kural\nand what it means, then\nrecord them reciting it",
        alreadySubmitted: "You've already submitted a video for this week!\nCome back next week to submit again.",
        entrySuccess: "Your entry is successful!\nWin a ",
        cycle: "bicycle every hour*,",
        trip: "a trip to Kanyakumari!",
      },
      kural: {
        prev: "Prev",
        next: "Next",
      },
      popup: {
        howToPlay: "How to Play",
        level1: "LEVEL 1",
        level1Text: "Scan a biscuit with a\nkural word on it.",
        level1Reward: "Claim your Amazon pay voucher!",
        level2: "LEVEL 2",
        level2Text: "Complete the kural using more\n biscuits, or fill it yourself.",
        level2Video: "Send a recording of you reciting\n the kural to ",
        level2Win: "WIN BIG!",
        scanBiscuit: "Scan Biscuit",
        congrats: "Congratulations!",
        completedKural: "You have completed\nyour Kural!",
        teachChild: "Learn the meaning of the\nKural and record a video of\nyou/your child reciting it.",
        oopsTitle: "OOPS",
        oopsText: "Wrong answer.\nTry again!",
        goBack: "Go Back",
        selectKuralVideo: "Select Kural to record\nVideo for Level 2",
        selectKuralType: "Select Kural to Type",
        continue: "Continue",

        // ── ShareVideo: instructions popup ──────────────────────────────
        videoInstructions: "Video Instructions",
        videoRule1: "Maximum length of video = 60 seconds.",
        videoRule2: "You are allowed one submission per week.",
        videoRule3: "Come in front of the screen and record a clear video which has face and audio.",

        // ── ShareVideo: cooldown error (submitted this week) ────────────
        alreadySubmittedTitle: "Already Submitted!",
        alreadySubmittedLine1: "You've already submitted a video for this week!",
        alreadySubmittedLine2: "Come back next week to submit again.",

        // ── ShareVideo: success / entry confirmed ────────────────────────
        stayTunedTitle: "Stay Tuned!",
        entrySuccessText: "Your entry is successful!\nWin a ",
        cycle: "bicycle every hour*,",
        trip: "a trip to Kanyakumari!",
        yourEntrySuccessful: "Your Entry is Successful!",
        continueBtn: "Continue",

        // ── ShareVideo: per-kural duplicate popup ────────────────────────
        kuralAlreadySubmittedTitle: "You have already recorded a video for this Kural",
        kuralAlreadySubmittedText: "Please try with another Kural.",

        // ── ShareVideo: camera access denied popup ───────────────────────
        cameraAccessTitle: "Camera Access Required",
        cameraAccessText: "Please allow camera and microphone access to record your video.",
        cameraAccessButton: "Grant Access",

        // ── ShareVideo: generic upload failure popup ─────────────────────
        videoSubmissionFailedTitle: "Submission Failed",
        videoSubmissionFailedText: "Video submission failed. Please try again later!",

        // ── Shared navigation labels ─────────────────────────────────────
        goBackTamil: "Go Back",
        tutorial: "Tutorial",
      },

      // ── Backend error messages (submitVideo) ──────────────────────────
      // Each key maps to exactly one backend response message.
      errors: {
        // 401
        unauthorized: "You are not logged in. Please log in and try again.",
        // 400 — no file sent
        missingFile: "No video file was received. Please try recording again.",
        // 404
        userNotFound: "Your account could not be found. Please log in again.",
        // 400 — per-kural duplicate (backend includes kural number in message)
        kuralAlreadySubmitted: "You have already submitted a video for this Kural.",
        // 400 — 7-day cooldown (backend includes remaining days in message)
        cooldownTitle: "Already Submitted!",
        cooldownLine1: "You've already submitted a video this week.",
        cooldownLine2: "Come back next week to submit again.",
        // 400 — no scans left
        noScans: "You have no scans left to submit a video.",
        // 400 — no kural completed yet
        noKuralCompleted: "Please complete at least one Kural before submitting a video.",
        // 500 / unknown
        serverError: "Something went wrong on our end. Please try again later.",
        // fallback for any unrecognised backend message
        generic: "Submission failed. Please try again.",
      },

      claimCashback: {
        congratulations: "Congratulations!",
        step1Text: "You have won an Amazon Pay voucher. You will receive an SMS within 10 days to redeem your voucher.",
        step1Button: "Continue",
        step2Text: "Your cashback will be credited within 10 days!",
        step2Button: "Continue",
      },
      welcomeBack: {
        message: "Just a few words away!\nComplete your Kural, submit a video and ",
        messageBoldPart: "win a bicycle every hour*, a trip to Kanyakumari!",
        continue: "Continue",
      },
      menu: {
        rewards: "REWARDS",
        howToPlay: "HOW TO PLAY",
        contactUs: "CONTACT US",
        privacyPolicy: "PRIVACY POLICY",
        termsAndConditions: "TERMS AND CONDITIONS",
        goBack: "Go Back",
        buymore: "BUY MORE"
      },
      contactUs: {
        needAssistance: "Need assistance?",
        emailUs: "Drop us an email at",
        email: "feedback@britindia.com",
        getBack: "We'll get back to you soon!",
      },
      banner: {
        cashbackTitle: "Guaranteed cashback",
        cashbackSubtitle: "& bicycles every hour!"
      }
    },
  },
  ta: {
    translation: {
      common: {
        terms: "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
        privacy: "தனியுரிமைக் கொள்கை.",
        and: "மற்றும்",
        okay: "ஓகே",
        continue: "கண்டின்யூ",
        goBack: "திரும்ப செல்ல",
        retry: "மீண்டும் முயற்சி",
        scan: "ஸ்கேன்",
        getHelp: "உதவி பெற",
        pleaseWait: "காத்திருக்கவும்...",
        next: "நெக்ஸ்ட்",
        enter: "நெக்ஸ்ட்",
        verifying: "சரிபார்க்கிறது...",
        uploading: "சமர்ப்பிக்கிறது...",
        submit: "சமர்ப்பிக்கவும்",
        review: "மீண்டும் பதிவு",
        language: "மொழி",
        chooseYourLanguage: "உங்க மொழி செலக்ட்\n பண்ணுங்க",
        tamil: "தமிழ்",
        english: "இங்கிலிஷ்",
        desktopInterest: "பங்கேற்க நீங்கள் காட்டிய ஆர்வத்திற்கு நன்றி",
        desktopQr: "அனுபவத்தைத் தொடங்க உங்கள் மொபைலில் QR குறியீட்டை ஸ்கேன் செய்யவும் :",
        rotate_message: "இந்த இணையதளம் கிடைமட்டப் பயன்முறையை ஆதரிக்காது.",
        rotate_messageBoldPart: "தயவுசெய்து இணையதளத்தை செங்குத்து பயன்முறையில் பயன்படுத்தவும்!",
        buymore: "பை மோர்"
      },
      auth: {
        signUp: "சைன் அப்",
        logIn: "லாகின்",
        name: "பெயர்",
        phoneNumber: "போன் நம்பர்",
        phoneNumberLabel: "கரெக்ட் போன் நம்பர் என்டர் பண்ணுங்க",
        state: "ஸ்டேட்",
        completeKurals: "குறளை கம்ப்ளீட் பண்ணுங்க, \nரிவார்ட்ஸ் வின் பண்ணுங்க!",
        invalidPhone: "கரெக்ட் போன் நம்பர் என்டர் பண்ணுங்க",
        agreeError: "விதிமுறைகள் மற்றும் நிபந்தனைகளுக்கு ஒப்புக்கொள்ளவும்.",
        stateError: "உங்கள் மாநிலத்தைத் தேர்ந்தெடுக்கவும்.",
        registrationFailed: "பதிவு தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.",
        agreeText: "பதிவு செய்யும்போது நீங்கள் எங்கள்",
        alreadyRegistered: "ஆல்ரெடி ரெஜிஸ்டர்டா?",
        dontHaveAccount: "கணக்கு இல்லையா?",
        signUpLink: "பதிவு செய்க",
        logInLink: "லாகின் பண்ணுங்க",
        sendingOtp: "அனுப்புகிறது...",
        loggedIn: "ஓகே",
        otp: "ஓடிபி என்டர் பண்ணுங்க",
        enterOtp: "ஓடிபி என்டர் பண்ணுங்க",
        otpSent: "அனுப்பப்பட்டது",
        enterAllDigits: "6 இலக்கங்களையும் உள்ளிடவும்",
        wrongOtp: "தவறான OTP",
        codeExpire: "குறியீடு காலாவதியாகும் நேரம் :",
        resendCode: "குறியீட்டை மீண்டும் அனுப்பு",
        otpVerify: "சரிபார்க்கப்பட்டது",
        done: "முடிந்தது",
        go: "செல்!",
        otpResent: "மீண்டும் அனுப்பப்பட்டது",
        tryLater: "பின்னர் மீண்டும் முயற்சிக்கவும்",
      },
      dashboard: {
        greeting: "ஹை யூசர் {{name}}",
        kuralOptionsInstruction: "மேலும் ஆப்ஷன்ஸ் பார்க்க ஏதாவது ஒரு குறளை கிளிக் செய்யுங்கள்.",
        scanInstruction: "பாக்கெட்ல இருக்குற பிஸ்கட்டை ஸ்கேன் பண்ணுங்க. இல்லனா மிஸ்ஸிங் வர்ட்ஸை டைப் பண்ணுங்க.",
        scanBiscuit: "பிஸ்கட் ஸ்கேன்\n பண்ணுங்க",
        recordVideo: "வீடியோ பதிவு",
        scanStep: "பிஸ்கட் ஸ்கேன்",
        completeStep: "குறளை நிறைவு செய்",
        sendVideoStep: "வீடியோ பதிவை அனுப்பு",
        level1: "லெவல் 1",
        level2: "லெவல் 2",
        howLevel1: "குறள் சொல் உள்ள பிஸ்கட்டை\nஸ்கேன் செய்யவும்.",
        claimReward: "உங்கள் கேஷ்பேக் பரிசைப் பெறுங்கள்!",
        howLevel2: "மேலும் பிஸ்கட்டுகளைப் பயன்படுத்தி குறளை நிறைவு செய்யவும் அல்லது நீங்களே நிரப்பவும்.",
        howVideo: "நீங்கள் குறளை ஓதுவதைக்\nகாணொளியாக அனுப்பி",
        winBig: " பெரிய பரிசை வெல்லுங்கள்!",
        kuralTitle: "குறள் {{id}}",
        menuRewards: "பரிசுகள்",
        menuHowToPlay: "விளையாடும் முறை",
        menuContactUs: "எங்களை தொடர்புகொள்ள",
        menuTerms: "விதிமுறைகள் மற்றும்\nநிபந்தனைகள்",
        TypeKural: "பிஸ்கட் ஸ்கேன் \nபண்ணுங்க",
        WrongWord: "தவறான பதில்.\nமீண்டும் முயற்சிக்கவும்!",
      },
      reward: {
        level1Badge: "லெவல் 1",
        level1Text: "ஒரு பிஸ்கட்டில் உள்ள குறள் சொல்லை ஸ்கேன் செய்யுங்கள்.",
        level1Strong: "உங்கள் உறுதியான கேஷ்பேக் பரிசை பெறுங்கள்!",
        level2Badge: "லெவல் 2",
        level2Text: "ஒரு குறளை முடித்து, உங்கள் குழந்தைக்கு கற்றுக்கொடுத்து,அதை அவர்கள் சொல்லும் வீடியோவை ரெகார்ட் செய்யுங்கள் —",
        level2Strong: "ஒவ்வொரு மணி நேரமும் ஒரு சைக்கிள் வெல்லுங்கள், மேலும் கன்னியாகுமரிக்கு போகும் வாய்ப்பை பெறுங்கள்!",
      },
      scan: {
        packDetails: "ஸ்கேன் பேக் டீடெயில்ஸ்",
        machinePrompt: "உங்கள் biscuit பாக்கெட் பின்புறத்தில் உள்ள 16 Digit நம்பரை ஸ்கேன் செய்யவும்",
        machineSuccess: "மெஷின் குறியீடு\nவெற்றிகரமாக ஸ்கேன் செய்யப்பட்டது!",
        capturedAlt: "பிடிக்கப்பட்ட படம் - மெஷின் குறியீட்டைத் தொடவும்",
        level1: "லெவல் 1:",
        level2: "லெவல் 2:",
        scanBiscuit: "பிஸ்கட் ஸ்கேன் பண்ணுங்க",
        recordVideo: "வீடியோ ரெக்கார்ட் பண்ணுங்க",
        scanYourKural: "குரல் பிஸ்கட்டை ஸ்கேன் செய்யவும்",
        scanningBiscuit: "உங்கள் பிஸ்கட்டை ஸ்கேன் செய்கிறது...",
        holdStill: "அசையாமல் பிடிக்கவும்",
        cameraNotFound: "கேமரா கிடைக்கவில்லை.",
        cameraAccess: "கேமரா அனுமதியை வழங்கவும் அல்லது கேமராவை இணைக்கவும்.",
        scanFailed: "ஸ்கேன் தோல்வியடைந்தது.",
        tryAgain: "மீண்டும் முயற்சிக்கவும்.",
        congratsLevel1: "நீங்கள் Amazon வவுச்சர் வென்றுள்ளீர்கள்!நீங்கள் திருக்குறள் பிஸ்கட்டை கண்டுபிடித்ததால்Level 2-க்கு தேர்வாகியுள்ளீர்கள்!பரிசைப் பெற கீழே கிளிக் செய்யவும்",
        foundError: "ஏதோ தவறு ஏற்பட்டது. மீண்டும் முயற்சிக்கவும்.",
        machineCodeAlreadyScanned: "இந்த மெஷின் குறியீடு ஏற்கனவே ஸ்கேன் செய்யப்பட்டுள்ளது.",
        noBiscuit: "பிஸ்கட் கண்டறியப்படவில்லை. மீண்டும் முயற்சிக்கவும்.",
        noBiscuitVisible: "பிஸ்கட் கண்டறியப்படவில்லை. பிஸ்கட் தெளிவாக தெரிகிறதா என்று பார்க்கவும்.",
        textUnclear: "எழுத்து தெளிவாக இல்லை. கேமராவை லெவல்யாகப் பிடிக்கவும்.",
        textUnreadable: "எழுத்து படிக்க முடியவில்லை. நல்ல வெளிச்சத்தில் முயற்சிக்கவும்.",
        alreadyScanned: "இந்தப் பிஸ்கட்டை ஏற்கனவே ஸ்கேன் செய்துவிட்டீர்கள். வேறு ஒரு குறள் வார்த்தை பிஸ்கட்டை ஸ்கேன் செய்யுங்கள்.",
        genericError: "பிழை ஏற்பட்டது. மீண்டும் முயற்சிக்கவும்.",
        invalidMobile: "சரியான மொபைல் எண்ணை உள்ளிடவும்.\nமீண்டும் முயற்சிக்கவும்.",
        invalidSku: "16 Digit நம்பரை ஸ்கேன் செய்ய \n முடியவில்லை. மீண்டும் முயற்சிக்கவும்!",
        notConfigured: "16 Digit நம்பரை ஸ்கேன் செய்ய \n முடியவில்லை. மீண்டும் முயற்சிக்கவும்!",
        mobileMismatch: "மொபைல் நம்பர்\nபொருந்தவில்லை. மீண்டும் முயற்சிக்கவும்!",
        serviceError: "சேவை கிடைக்கவில்லை.\nமீண்டும் முயற்சிக்கவும்!",

        // ── Specific biscuit-scan failure reasons ──
        // (contains \n so the "மீண்டும் ஸ்கேன் செய்யவும்." part renders bold on its own line)
        nonKuralBiscuit: "இது குறள் வார்த்தை பிஸ்கட் இல்லை. சரியான பிஸ்கட்டை மீண்டும் ஸ்கேன் செய்யுங்கள்.",
        multipleBiscuits: "ஒன்றுக்கும் மேற்பட்ட பிஸ்கட் தெரிகிறது. ஒரே ஒரு பிஸ்கட்டை மட்டும் மீண்டும் ஸ்கேன் செய்யுங்கள்.",
        noBiscuitDetected: "பிஸ்கட் எதுவும் தெரியவில்லை. பிஸ்கட்டை வைத்து மீண்டும் ஸ்கேன் செய்யுங்கள்.",
      },
      video: {
        unableAccess: "கேமரா அல்லது மைக்ரோஃபோனை அணுக முடியவில்லை. அனுமதிகளைச் சரிபார்க்கவும்.",
        noVideo: "வீடியோ கிடைக்கவில்லை",
        uploadFailed: "பதிவேற்றம் தோல்வியடைந்தது",
        clickStart: "பதிவை தொட கிளிக் செய்யவும்",
        recording: "பதிவு செய்கிறது... {{time}}",
        completedKural: "நீங்கள் உங்கள்\nகுறளை நிறைவு செய்துள்ளீர்கள்!",
        teachChild: "குழந்தைக்கு குறளையும் அதன் பொருளையும் கற்றுக்கொடுத்து\nஅதன் பொருளை சொல்லிக்கொடுத்து\nஅதை ஓதும் காணொளியை பதிவு செய்யவும்",
        alreadySubmitted: "இந்த வாரத்திற்கான வீடியோவை நீங்கள் ஏற்கனவே சமர்ப்பித்துவிட்டீர்கள்!\nமீண்டும் சமர்ப்பிக்க அடுத்த வாரம் வாருங்கள்.",
        entrySuccess: "உங்கள் பதிவு வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது!\nவெல்லுங்கள் ",
        cycle: "ஒவ்வொரு மணிநேரமும் ஒரு சைக்கிள்",
        trip: "கன்னியாகுமரி பயணம்!",
      },
      kural: {
        prev: "முந்தையது",
        next: "அடுத்தது",
      },
      popup: {
        howToPlay: "எப்படி விளையாடுவது",
        level1: "லெவல் 1",
        level1Text: "குரல் வார்த்தையுடன் உள்ள ஒரு பிஸ்கட்டை\nஸ்கேன் செய்யவும்.",
        level1Reward: "உங்கள் Amazon Pay வவுச்சரைப் பெற்றுக்கொள்ளுங்கள்!",
        level2: "லெவல் 2",
        level2Text: "மேலும் பிஸ்கட்டுகளைப் பயன்படுத்தி\nகுறளை நிறைவு செய்யவும் அல்லது\nநீங்களே நிரப்பவும்.",
        level2Video: "நீங்கள் குறளை ஓதுவதைக்\nகாணொளியாக அனுப்பி",
        level2Win: "பெரிய பரிசை வெல்லுங்கள்!",
        scanBiscuit: "பிஸ்கட் ஸ்கேன்",
        congrats: "வாழ்த்துகள்!",
        completedKural: "நீங்கள் உங்கள்\nகுறளை நிறைவு செய்துள்ளீர்கள்!",
        teachChild: "குழந்தைக்கு குறளையும்\nஅதன் பொருளையும் கற்றுக்கொடுத்து\nஅதை ஓதும் காணொளியை\nபதிவு செய்யவும்",
        oopsTitle: "அச்சச்சோ",
        oopsText: "தவறான பதில்.\nமீண்டும் முயற்சிக்கவும்!",
        goBack: "திரும்ப செல்ல",
        selectKuralVideo: "லெவல் 2க்கு\nவீடியோ பதிவு செய்ய\nகுறளைத் தேர்வுசெய்யுங்கள்",
        selectKuralType: "குறளைத் தட்டச்சு\nசெய்யத் தேர்வுசெய்யுங்கள்",
        continue: "கண்டின்யூ",

        // ── ShareVideo: instructions popup ──────────────────────────────
        videoInstructions: "வீடியோ வழிமுறைகள்",
        videoRule1: "வீடியோவின் அதிகபட்ச நீளம் = 60 விநாடிகள்.",
        videoRule2: "நீங்கள் ஒரு வாரத்திற்கு ஒரு சமர்ப்பிப்பு அனுமதிக்கப்படுகிறது.",
        videoRule3: "முகமும் குரலும் தெளிவாக தெரியும் வகையில் கேமரா முன் நின்று வீடியோ பதிவு செய்யவும்.",

        // ── ShareVideo: cooldown error (submitted this week) ────────────
        alreadySubmittedTitle: "ஏற்கனவே சமர்ப்பித்துவிட்டது!",
        alreadySubmittedLine1: "இந்த வாரத்துக்கு உங்கள் வீடியோ ஏற்கனவே அனுப்பப்பட்டுள்ளது.",
        alreadySubmittedLine2: "அடுத்த வாரம் மீண்டும் அனுப்பலாம்.",

        // ── ShareVideo: success / entry confirmed ────────────────────────
        stayTunedTitle: "கவனமாக இருங்கள்!",
        entrySuccessText: "உங்கள் பதிவு வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது!\nவெல்லுங்கள் ",
        cycle: "ஒவ்வொரு மணிநேரமும் ஒரு சைக்கிள்",
        trip: "கன்னியாகுமரி பயணம்!",
        yourEntrySuccessful: "உங்கள் பதிவு வெற்றிகரமாக உள்ளது!",
        continueBtn: "கண்டின்யூ",

        // ── ShareVideo: per-kural duplicate popup ────────────────────────
        kuralAlreadySubmittedTitle: "இந்தக் குறளுக்காக நீங்கள் ஏற்கனவே ஒரு காணொளியைப் பதிவு செய்துள்ளீர்கள்.",
        kuralAlreadySubmittedText: "தயவுசெய்து வேறு குறளை முயற்சிக்கவும்.",

        // ── ShareVideo: camera access denied popup ───────────────────────
        cameraAccessTitle: "கேமரா அணுகல் தேவை",
        cameraAccessText: "வீடியோ பதிவு செய்ய கேமரா மற்றும் மைக்ரோஃபோன் அனுமதியை வழங்கவும். உங்கள் உலாவி அமைப்புகளை சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
        cameraAccessButton: "அனுமதி வழங்கவும்",

        // ── ShareVideo: generic upload failure popup ─────────────────────
        videoSubmissionFailedTitle: "சமர்ப்பிப்பு தோல்வியடைந்தது",
        videoSubmissionFailedText: "காணொளி சமர்ப்பிப்பு தோல்வியடைந்தது. தயவுசெய்து பின்னர் மீண்டும் முயற்சிக்கவும்!",

        // ── Shared navigation labels ─────────────────────────────────────
        goBackTamil: "திரும்பு",
        tutorial: "பயிற்சி",
      },

      // ── Backend error messages (submitVideo) ──────────────────────────
      errors: {
        // 401
        unauthorized: "நீங்கள் உள்நுழையவில்லை. தயவுசெய்து உள்நுழைந்து மீண்டும் முயற்சிக்கவும்.",
        // 400 — no file
        missingFile: "வீடியோ கோப்பு கிடைக்கவில்லை. தயவுசெய்து மீண்டும் பதிவு செய்யவும்.",
        // 404
        userNotFound: "உங்கள் கணக்கு கிடைக்கவில்லை. தயவுசெய்து மீண்டும் உள்நுழையவும்.",
        // 400 — per-kural duplicate
        kuralAlreadySubmitted: "இந்தக் குறளுக்காக நீங்கள் ஏற்கனவே ஒரு வீடியோவை சமர்ப்பித்துவிட்டீர்கள்.",
        // 400 — 7-day cooldown
        cooldownTitle: "ஏற்கனவே சமர்ப்பித்துவிட்டது!",
        cooldownLine1: "இந்த வாரத்துக்கு உங்கள் வீடியோ ஏற்கனவே அனுப்பப்பட்டுள்ளது.",
        cooldownLine2: "அடுத்த வாரம் மீண்டும் அனுப்பலாம்.",
        // 400 — no scans left
        noScans: "வீடியோ சமர்ப்பிக்க உங்களிடம் ஸ்கேன்கள் எதுவும் இல்லை.",
        // 400 — no kural completed
        noKuralCompleted: "வீடியோ சமர்ப்பிக்கும் முன் குறைந்தது ஒரு குறளையாவது முடிக்கவும்.",
        // 500 / unknown
        serverError: "சேவையகத்தில் பிழை ஏற்பட்டது. தயவுசெய்து சிறிது நேரம் கழித்து மீண்டும் முயற்சிக்கவும்.",
        // fallback
        generic: "சமர்ப்பிப்பு தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.",
      },

      claimCashback: {
        congratulations: "",
        step1Text: "நீங்கள் Amazon வவுச்சர் வென்றுள்ளீர்கள்! நீங்கள் திருக்குறள் பிஸ்கட்டை கண்டுபிடித்ததால்Level 2-க்கு தேர்வாகியுள்ளீர்கள்! பரிசைப் பெற கீழே கிளிக் செய்யவும்",
        step1Button: "கன்டினியூ",
        step2Text: "உங்கள் வவுச்சர் 30 நாட்களுக்குள் கிரெடிட் செய்யப்படும்!",
        step2Button: "கன்டினியூ",
      },
      welcomeBack: {
        message: "உங்கள் குறளை முடித்து,வீடியோ பதிவு செய்து அனுப்புங்கள்!\nஒவ்வொரு மணிநேரமும் ஒரு சைக்கிள் +கன்னியாகுமரி சுற்றுலா வாய்ப்பைப் பெறுங்கள்! ",
        messageBoldPart: "",
        continue: "கண்டின்யூ",
      },
      menu: {
        rewards: "பரிசுகள்",
        howToPlay: "விளையாடும் முறை",
        contactUs: "காண்டாக்ட் அஸ்",
        privacyPolicy: "எங்களை தொடர்புகொள்ள",
        termsAndConditions: "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
        goBack: "திரும்ப செல்ல",
        buymore: "பை மோர்"
      },
      contactUs: {
        needAssistance: "உதவி தேவையா?",
        emailUs: "எங்களுக்கு மின்னஞ்சல் அனுப்புங்கள்:",
        email: "feedback@britindia.com",
        getBack: "விரைவில் உங்களை தொடர்புகொள்கிறோம்!",
      },
      banner: {
        cashbackTitle: "உறுதியான கேஷ்பேக் மேலும்",
        cashbackSubtitle: "ஒவ்வொரு மணிநேரமும் சைக்கிள்கள் வெல்லுங்கள்!*"
      }
    },
  },
};

const savedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
const initialLanguage = savedLanguage === "ta" || savedLanguage === "en" ? savedLanguage : "en";

const applyDocumentLanguage = (language) => {
  document.documentElement.lang = language;
  document.documentElement.dataset.appLanguage = language;
};

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (language) => {
  applyDocumentLanguage(language);
  localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
});

applyDocumentLanguage(initialLanguage);

export default i18n;